import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  useIsAuthenticated,
  useMsal,
  AuthenticatedTemplate,
} from "@azure/msal-react";
import ATSLogo from "../assets/images/ATSlogo.png";
import { useAuth } from "../context/AuthContext";
import "../assets/styles/MainLayout.css";

const MainLayout = ({ children }) => {
  const isAuthenticatedMSAL = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const { logout } = useAuth(); //user
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  const isAuthenticated = isAuthenticatedMSAL;// || !!user;

  const handleLogout = () => {
    if (isAuthenticatedMSAL) {
      instance.logoutRedirect();
    } else {
      logout();
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = isMenuOpen ? "auto" : "hidden";
  };

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  const navItems = [
    { to: "/dashboard", text: "Dashboard" },
    { to: "/manageusers", text: "Users" },
    // { to: "/workflow", text: "Workflow" },
    { to: "/analytics", text: "Analytics" },
    { to: "/createTower", text: "Create a Tower" },
  ];

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="d-flex flex-column vh-100">
      <nav className="navbar fixed-top navbar-expand-lg bg-body-tertiary shadow-sm">
        <div className="container-fluid">
          <Link
            className="navbar-brand ps-3"
            to={isAuthenticated ? "/dashboard" : "/"}
          >
            <img
              src={ATSLogo}
              alt="ATS Logo"
              width={100}
              height="auto"
              className="img-fluid"
            />
          </Link>

          <div className="d-flex d-lg-none align-items-center ms-auto">
            <AuthenticatedTemplate>
              <span className="me-3">
                Welcome, {accounts[0]?.name?.split(" ")[0] || "Guest"}
              </span>
            </AuthenticatedTemplate>
            <button
              className="navbar-toggler me-3"
              type="button"
              onClick={toggleMenu}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
          <div className="d-none d-lg-flex justify-content-center flex-grow-1">
            <ul className="navbar-nav">
              {isAuthenticated &&
                navItems.map((item, index) => (
                  <li
                    key={index}
                    className={`nav-item ${item.submenu ? "dropdown" : ""}`}
                    ref={item.submenu ? dropdownRef : null}
                  >
                    {item.submenu ? (
                      <>
                        <button
                          className="nav-link dropdown-toggle"
                          onClick={() => toggleDropdown(index)}
                          aria-expanded={openDropdown === index}
                        >
                          {item.text}
                        </button>
                        <ul
                          className={`dropdown-menu ${
                            openDropdown === index ? "show" : ""
                          }`}
                        >
                          {item.submenu.map((subItem, subIndex) => (
                            <li key={subIndex}>
                              <Link
                                className="dropdown-item"
                                to={subItem.to}
                                onClick={() => setOpenDropdown(null)}
                              >
                                {subItem.text}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <Link
                        className={`nav-link ${
                          location.pathname === item.to ? "active" : ""
                        }`}
                        to={item.to}
                        onClick={() => setOpenDropdown(null)}
                      >
                        {item.text}
                      </Link>
                    )}
                  </li>
                ))}
            </ul>
          </div>
          <div className="d-none d-lg-flex align-items-center pe-3">
            {isAuthenticated && (
              <span className="me-3">
                Welcome, {accounts[0]?.name?.split(" ")[0] || "Guest"}!
              </span>
            )}
            {isAuthenticated ? (
              <button className="btn btn-outline-danger" onClick={handleLogout}>
                Logout
              </button>
            ) : (
              <Link className="btn btn-success" to="/login">
                Login
              </Link>
            )}
          </div>
        </div>
      </nav>
      <div
        className={`menu-overlay ${isMenuOpen ? "visible" : ""}`}
        onClick={toggleMenu}
      ></div>
      <div className={`slide-menu ${isMenuOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={toggleMenu}>
          &times;
        </button>
        <ul className="navbar-nav">
          {isAuthenticated ? (
            <>
              {navItems.map((item, index) => (
                <li key={index} className="nav-item">
                  {item.submenu ? (
                    <>
                      <span className="nav-link">{item.text}</span>
                      <ul className="navbar-nav ms-3">
                        {item.submenu.map((subItem, subIndex) => (
                          <li key={subIndex} className="nav-item">
                            <Link
                              className="nav-link"
                              to={subItem.to}
                              onClick={toggleMenu}
                            >
                              {subItem.text}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <Link
                      className="nav-link"
                      to={item.to}
                      onClick={toggleMenu}
                    >
                      {item.text}
                    </Link>
                  )}
                </li>
              ))}
              <li className="nav-item align-self-center mt-3">
                <button
                  className="btn btn-outline-danger"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </li>
            </>
          ) : (
            <li className="nav-item">
              <Link
                className="btn btn-outline-success"
                to="/login"
                onClick={toggleMenu}
              >
                Login
              </Link>
            </li>
          )}
        </ul>
      </div>
      <main className="flex-grow-1 mt-5 pt-3 px-2 overflow-hidden">
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
